import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { NEW_INVITATION_ERRORS } from './new-invitation-errors';

@Pipe({
  name: 'newInvitationError',
})
export class NewInvitationErrorPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(errorType: string): any {
    if (errorType && NEW_INVITATION_ERRORS[errorType]) {
      return this.translateService.instant(NEW_INVITATION_ERRORS[errorType]);
    }

    return this.translateService.instant(NEW_INVITATION_ERRORS['OTHER']);
  }
}
